<template>
  <div class="invitecode" v-if="visible">
    <div class="invitecode__panel" @click.stop>
       <div class="progress">
        <div class="progress_indicator"></div>
        <div class="progress_indicator"></div>
        <div class="progress_indicator progress_indicator_mark"></div>
      </div>
      <div class="invitecode__content">
        <template>
          <div class="invitecode__brand">
            {{ $t('message.inviteCode.title') }}
          </div>
          <div class="invitecode__form">
        
            <div class="invitecode__form_item invitecode__form_item-input">
              <span class="area-code">&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <input
                class="vcode"
                type="text"
                v-model="inviteCode"
                :placeholder="$t('message.inviteCode.placeholder')"
                maxLength="6"
                minLength="6"
                @blur="onBlur"
                @focus="onFocus"
              />
        
            </div>
            	<!-- <div class="invitecode__form_item-errorinfo" v-if="errorInfo!=null">
								<div class="invitecode__form_item-errorinfo_icon">!</div>
								<div>{{errorInfo}}</div>
							</div> -->

              <div :class="inviteCode.length>0?'invitecode__form_item-button':'invitecode__form_item-button-disable'"
                    class="invitecode__form_item global_pointer"
                    @click="bind"
                >
                    {{ $t("message.inviteCode.next") }}
              </div>
            <!-- <div class="invitecode__form_item invitecode__form_item-button global_pointer" @click="bind">
            {{ $t('message.inviteCode.next') }}
            </div> -->
            <div class="invitecode__skip global_pointer" @click="skip">
            {{ $t('message.inviteCode.skip') }}
            </div>
          </div>
        </template>
      </div>
    </div>
  
  </div>
</template>

<script>
import api from '@/api/api_list';
import { bindInviteCodeKey } from "@/constant/storageKey";
export default {
  name: 'bindInviteCode',
  data() {
    return {
      visible: false,
      complete:null,
      inviteCode:null,
      errorInfo:null
    };
  },
  mounted() {
  },
  methods: {
    bind() {
      
      if (!this.inviteCode) {
        this.$toast(this.$t('message.inviteCode.inputToast'));
        return;
      }
      
      api
        .bind_invite_code({
          code: this.inviteCode,
          source: 'H5'
        })
        .then((res) => {
          if(res.code == 0){
            let result = res.result
            try {
              const { userNum } = this.$storage.get('user_info') || {}
              this.$storage.set(bindInviteCodeKey + userNum, true);
            } catch (error) {
              
            }
            this.visible = false

            // 打点 - 用户成功绑定邀请码 （219需求）
            // 需求文档  https://rt04ged6sr.feishu.cn/sheets/shtcnbL03mV9XyamH5n3Z36aKYd?sheet=yD3F1w
            try{
              this.sa.track({
                eventId: 'referralCodeSuccessful',
                eventParam: {
                  bindingSource: 'H5',
                  platformType: 'H5',
                }
              });
            }catch(e){
              console.log(e)
            }

            // 绑定成功 - complete(true|false) , true表示需要展示downloadGuide.vue否则不需要展示
            if (result.exchangeCodeType==3) {
              this.complete ? this.complete(true) : null ;
            }else if (result.exchangeCodeType==1||result.exchangeCodeType==2) {
              this.$toast(result.unifiedMarkedWords)
            }


          }else{
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
        });
    },
    skip(){
      this.visible = false
      this.complete ? this.complete(false) : null ;
    },
    onFocus(evt) {
      let element = evt.target
      element.scrollIntoView(true);
      element.scrollIntoViewIfNeeded(true);
    },
    onBlur() {
      // 设置body恢复原来的高度
      // document.getElementsByTagName('body')[0].style.height = `${window.innerHeight}px`;
    },
    resetForm(){
      this.inviteCode = ''
    },
    open(input={}){
      let {bindComplete} = input
      this.resetForm()
      this.visible = true

      this.complete = bindComplete
    
    }
  },
};
</script>


<style lang="less" scoped>
.invitecode {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
	background-color: rgba(0, 0, 0, 0.5);
  text-align: center;

  &__panel {
    position: absolute;
    width: 100%;
    background: #FEF7F0;
    left: 0;
    bottom: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    overflow: hidden;
    z-index: 110;
    &_close{
      width: 26px;
      height: 26px;
      position: absolute;
      right: 12px;
      top: 12px;
    }
  }

  .progress{

		z-index: 120;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: -76px;
    margin-left: -20px;
    left: 50%;

    &_indicator{
      width: 9px;
      height: 9px;
      margin-right: 2px;
      margin-left: 2px;
      border-radius: 9px;
      border: 1px solid #ffffff;
      &_mark{
        background-color: #ffffff;
      }
    }
    
  }
  &__line {
    border: 0;
    padding: 0;
    margin: 0;
    width: 100%;
    height: 8px;
    background: #c0ddde;
  }
  &__brand {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    margin-bottom: 24px;
    font-size: 24px;
    font-family: Approach-Regular, Approach;
    font-weight: 400;
    color: #0D0E13;
    line-height: 30px;
  }
  &__form {
    margin-bottom: 37px;
  }
  &__form_item {
    border-bottom: 1px solid #979797;
		width: 315px;
		height: 36px;
		line-height: 36px;
		margin: 0 auto 0px;
		box-sizing: border-box;
		text-align: left;
		padding: 0 11px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		font-family: PingFangSC-Regular, PingFang SC;
		position: relative;
    & input {
			border: 0;
			width: 275px;
			height: 19px;
			line-height: 19px;
			border-radius: 0;
			padding: 0 6px;
			margin-left: 6px;
			background-color: transparent !important;
			outline: none;
			font-family: "TradeGothicLT";
      text-align: center;

      font-size: 18px;
      font-weight: 400;
      color: #0D0E13;
		}

    // background: #f5f5f5;
    // border-radius: 18px;
    // border: 1px solid #f2f2f2;
    // width: 243px;
    // height: 36px;
    // line-height: 36px;
    // margin: 0 auto 16px;
    // box-sizing: border-box;
    // text-align: left;
    // padding: 0 11px;
    // display: flex;
    // align-items: center;
    // justify-content: flex-start;
    & .area {
      height: 19px;
      line-height: 19px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #161a1a;
    }
    // & input {
    //   border: 0;
    //   width: 160px;
    //   height: 19px;
    //   line-height: 19px;
    //   border-radius: 0;
    //   padding: 0 6px;
    //   margin-left: 6px;
    //   border-left: 1px solid #979797;
    //   background-color: transparent !important;
    //   outline: none;
    //   &.vcode {
    //     border-left: 0;
    //     padding-left: 0;
    //     margin-left: 0;
    //   }
    // }
    &_container{
      background-color: transparent;
      justify-content: space-between;
      padding: 0;
      border: 0;
    }
  }
  
  &__form_item-input{
		margin-bottom: 30px;
	}

  &__form_item-errorinfo{
		height: 30px;
		line-height: 30px;
		color: #D52300;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 12px;
		&_icon{
			font-size: 5px;
			width: 12px;
			height: 12px;
			line-height: 12px;
			margin-right: 4px;
			border-radius: 12px;
			border: 1px solid #D52300;
		}
	}

&__form_item-button {
		border: 0;
		background: #000000;
		border-radius: 30px;
		text-align: center;
		font-size: 14px;
		color: #ffffff;
		justify-content: center;
		width: 347px;
		height: 51px;
		line-height: 51px;
		// box-shadow: 0 2px 4px rgba(0, 0, 0, 0.37);
		&-disable {
			font-size: 14px;
			justify-content: center;
			width: 347px;
			height: 51px;
			line-height: 51px;
			color: #000000;
			background-color: transparent;
			border-radius: 30px;
			border: 1px solid #0D0E13;
			text-align: center;
		}
	}
  
  .disable {
    background: #3d3c3c;
  }

  &__skip {
      
    display: flex;
    justify-content:center;
    align-items:center;
    
      color: #4A4A4A;
      font-size: 14px;
      text-align: center;
      margin: 24px auto;
      text-decoration: underline;
  }

}
</style>